import { ClinicsUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

export const fetchClinics = () => {
  return new ClinicsUseCase('/clinicas', makeAxiosHttpClient())
}

export const deleteClinics = (id: number | string) => {
  return new ClinicsUseCase(`/clinicas?cdClinica=${id}`, makeAxiosHttpClient())
}

export const fetchAllClinics = () => {
  return new ClinicsUseCase(
    '/avaliacaoPsicologica/clinicas',
    makeAxiosHttpClient()
  )
}
